/** Decide o canal de uma conversa: app (lead vindo da área do cliente) vs whatsapp. */
export function canalDaConversa(cliente: { consumer_id?: string | null; origem?: string | null }): 'app' | 'whatsapp' {
  if (cliente.consumer_id || cliente.origem === 'app') return 'app';
  return 'whatsapp';
}

/** Estado do tique de leitura de UMA mensagem própria no chat app.
 *  cliente-enviada → lê-se pelo `lida` (a empresa leu); empresa-enviada → pelo `lida_consumer`. */
export function tiqueLeituraApp(m: { remetente: string; lida: boolean; lida_consumer: boolean }): 'enviada' | 'lida' {
  const lidoPeloOutro = m.remetente === 'cliente' ? m.lida : m.lida_consumer;
  return lidoPeloOutro ? 'lida' : 'enviada';
}

/** Throttle do broadcast "a escrever": só reenvia se passou `intervaloMs` desde o último envio. */
export function deveEnviarTyping(ultimoEnvioMs: number | null, agoraMs: number, intervaloMs = 2000): boolean {
  if (ultimoEnvioMs === null) return true;
  return agoraMs - ultimoEnvioMs >= intervaloMs;
}
